<template>
    
    <div class="desktop footer" v-if="db.profile.id">
        <div class="container">
            <div class="cols">
                <div class="logo">
                    

                    <div class="column left">
                        <svg width="51" height="10" viewBox="0 0 51 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M44.5273 9.57861C43.3678 9.57861 42.3586 9.38395 41.4995 8.99463C40.6405 8.60107 39.974 8.04671 39.5 7.33154C39.0303 6.61637 38.7954 5.77002 38.7954 4.79248V4.77979C38.7954 3.80225 39.0303 2.95589 39.5 2.24072C39.974 1.52555 40.6405 0.973307 41.4995 0.583984C42.3586 0.194661 43.3678 0 44.5273 0C45.6868 0 46.6961 0.194661 47.5552 0.583984C48.4142 0.973307 49.0786 1.52555 49.5483 2.24072C50.0223 2.95589 50.2593 3.80225 50.2593 4.77979V4.79248C50.2593 5.77002 50.0223 6.61637 49.5483 7.33154C49.0786 8.04671 48.4142 8.60107 47.5552 8.99463C46.6961 9.38395 45.6868 9.57861 44.5273 9.57861ZM44.5273 7.67432C45.1833 7.67432 45.7546 7.55794 46.2412 7.3252C46.7321 7.08822 47.1108 6.75391 47.3774 6.32227C47.644 5.88639 47.7773 5.37646 47.7773 4.79248V4.77979C47.7773 4.19157 47.644 3.68376 47.3774 3.25635C47.1108 2.82471 46.7321 2.4904 46.2412 2.25342C45.7546 2.01644 45.1833 1.89795 44.5273 1.89795C43.8672 1.89795 43.2938 2.01644 42.8071 2.25342C42.3205 2.4904 41.9438 2.82471 41.6772 3.25635C41.4106 3.68376 41.2773 4.19157 41.2773 4.77979V4.79248C41.2773 5.37646 41.4106 5.88639 41.6772 6.32227C41.9438 6.75391 42.3205 7.08822 42.8071 7.3252C43.2938 7.55794 43.8672 7.67432 44.5273 7.67432Z" fill="white"/>
<path d="M23.9932 9.36865V0.208984H26.8687L30.125 6.78516H30.1948L33.4448 0.208984H36.3203V9.36865H34.0986V3.25586H33.1592L34.8413 1.43408L30.9756 9.36865H29.3315L25.4722 1.43408L27.1543 3.25586H26.2148V9.36865H23.9932Z" fill="white"/>
<path d="M12.8599 9.36865V0.208984H21.2896V1.99902H15.291V3.92236H20.877V5.54736H15.291V7.57861H21.2896V9.36865H12.8599Z" fill="white"/>
<path d="M0 9.36865V0.208984H5.12256C6.25244 0.208984 7.20671 0.384603 7.98535 0.73584C8.76823 1.08708 9.36279 1.60124 9.76904 2.27832C10.1753 2.95117 10.3784 3.7679 10.3784 4.72852V4.74121C10.3784 5.73568 10.1753 6.5778 9.76904 7.26758C9.36279 7.95736 8.76823 8.47998 7.98535 8.83545C7.20671 9.19092 6.25244 9.36865 5.12256 9.36865H0ZM2.43115 7.52148H4.93213C5.56266 7.52148 6.09798 7.41992 6.53809 7.2168C6.98242 7.01367 7.31885 6.70898 7.54736 6.30273C7.78011 5.89648 7.89648 5.3929 7.89648 4.79199V4.7793C7.89648 4.19108 7.78434 3.69596 7.56006 3.29395C7.34001 2.8877 7.00781 2.58089 6.56348 2.37354C6.12337 2.16195 5.57959 2.05615 4.93213 2.05615H2.43115V7.52148Z" fill="white"/>
</svg>
                        <!-- <p><b>DEMO</b></p> -->
                        <p>{{tools.time.year()}} ©</p>
                    </div>
                </div>
            </div>

            <div class="cols">
                <router-link class="item" v-for="(item, index) in action" :key="index" :to="item.link">{{item.id}}</router-link>
            </div>

            <div class="cols">
                <router-link class="item" v-for="(item, index) in law" :key="index" :to="item.link">{{item.id}}</router-link>
            </div>

            <div class="cols">
                <router-link class="item" v-for="(item, index) in service" :key="index" :to="item.link">{{item.id}}</router-link>
            </div>
            
            
        </div>
        <p class="w800">{{ db.profile }}</p>
        
    </div>
    
    
    <div class="mobile footerMobile" v-if="db.profile.id" style="width: 100vw; overflow: hidden;">
        <div class="containerMobile">
            
            <div class="column center" style="margin-bottom: 2vh;">                
                    <svg width="34" height="38" viewBox="0 0 34 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.4228 15.8772L16.8726 18.9983L0 9.51145V9.50473L16.8976 0L33.772 9.49488L24.968 14.4459L17.5339 10.2625C17.2425 10.1146 16.9037 10.0819 16.5881 10.1713C16.2726 10.2607 16.0046 10.4653 15.8402 10.7424C15.6757 11.0195 15.6274 11.3477 15.7053 11.6586C15.7832 11.9696 15.9814 12.2392 16.2584 12.4114L22.4228 15.8772Z" fill="#ffffff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.8726 37.985L16.8976 37.9991L33.7896 28.4916V22.267L22.4159 15.8723L16.8726 18.9894V25.2132L17.534 25.585C17.811 25.7571 18.0092 26.0268 18.0871 26.3377C18.165 26.6486 18.1167 26.9769 17.9522 27.254C17.7878 27.5311 17.5198 27.7356 17.2043 27.825C17.0955 27.8559 16.984 27.8722 16.8726 27.8743V37.985ZM33.7655 9.49023L24.9611 14.441L33.7896 19.4091V9.50381L33.7655 9.49023Z" fill="#ffffff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 28.4978L16.8976 37.9998L16.9059 37.9951V27.874C16.683 27.8838 16.4594 27.8366 16.2584 27.7346L0 18.5925V28.4978ZM16.9059 25.2327L0 15.7292V9.50456L0.0185173 9.49414L16.9059 18.9901V25.2327Z" fill="#FFffff"/></svg>
                    
                    <div class="column">
                        <p>DEMO</p>
                        <p class="mini">{{tools.time.year() }} ©</p>
                    </div>
                
            </div>
            
            <div class="row wrap center " style="padding: 0 10vw;">
                <!-- <a class="item" :href="item.link" v-for="(item, index) in action" :key="index">{{item.id}}</a>
                <a class="item" :href="item.link" v-for="(item, index) in law" :key="index">{{item.id}}</a>
                <a class="item" :href="item.link" v-for="(item, index) in service" :key="index">{{item.id}}</a> -->
                <router-link class="item" style="margin: 0 10px;" v-for="(item, index) in action" :key="index" :to="item.link">{{item.id}}</router-link>
                <router-link class="item" style="margin: 0 10px;" v-for="(item, index) in law" :key="index" :to="item.link">{{item.id}}</router-link>
                <router-link class="item" style="margin: 0 10px;" v-for="(item, index) in service" :key="index" :to="item.link">{{item.id}}</router-link>
            </div>
            
        </div>
    </div>


    
    
</template>
<script>

export default {
    data: function () {return {
        action: [
            { id: 'Home', link:'/'},
            { id: 'Assets', link:'/assets'},
            { id: 'People', link:'/people'},
            { id: 'Top', link:'/top'},
            { id: 'Wait', link:'/wait'},
        ],
        law: [
            { id: 'Terms', link:'/about/terms'},            
            { id: 'Privacy', link:'/about/privacy'},            
            { id: 'Agreement', link:'/about/agreement'},            
            { id: 'GDPR', link:'/about/gdpr'},            
            { id: 'Complaints', link:'/about/complaints'},            
            { id: 'Data', link:'/about/data'},            
            { id: 'KYC', link:'/about/kyc'},            
        ],
        service: [
            { id: 'Support', link:'/'},
        ],
    }},
    components:{},
    props:{
        
    },
}
</script>


<style scoped>
.footer{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    padding: 50px 0 400px;
    background: var(--g03);
    margin-top: 20vh;
}

.footerMobile{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    padding: 50px 0 100px;
    background: var(--g03);
    margin-top: 10vh;
}

.container{
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 1200px;
    background: none;
}

.containerMobile{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    /* max-width: 1200px; */
    background: none;
}

.cols{
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 50px;
    align-items: flex-start;
    justify-content: flex-start;
}

.logo{
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.logo p{
    color:  var(--text);
    text-align: left;
    font-size: 11px;
    line-height: 15px;
    margin-left: 10px;
}


.item{
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.0em;
    color:  var(--g4);
    text-decoration: none;
    margin: 0 0px 6px;
    white-space: nowrap;
}
.item.router-link-exact-active{
    opacity: .3;
}
</style>

